import {Typography, Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

interface InstituteCardDataType {
  key: number;
  instituteLogo: string;
  instituteName: string;
  onImageLoad?: () => void;
}

const InstituteCard = ({
  key,
  instituteLogo,
  instituteName,
  onImageLoad,
}: InstituteCardDataType) => {
  return (
    <Box
      key={key}
      sx={{
        margin: '25px 10px 0 0',
        padding: '9px 0 0',
        borderRadius: '15px',
        border: 'solid 1px #ececf5',
        backgroundColor: '#fff',
        textAlign: 'center',
      }}
    >
      <Image
        src={instituteLogo}
        alt="Company Logo"
        width={130}
        height={70}
        layout="intrinsic"
      />
      <Box>
        <Typography
          variant="body1"
          sx={{
            display: 'inline-grid',
            placeItems: 'center',
            backgroundColor: '#ededf4',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: 'normal',
            borderRadius: '0 0 8px 8px',
            padding: '9px',
            minHeight: '46px',
            minWidth: '158px',
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {instituteName}
        </Typography>
      </Box>
    </Box>
  );
};

export default InstituteCard;
